import { ReactNode } from 'react';
import styled from 'styled-components';

const StyledButtonWrap = styled.div`
    display: flex;
    margin-bottom: 1rem;
    position: relative;
    @media(max-width: 767px) {
        display: flex;
        justify-content: center;
        margin-bottom: 1rem;
    }
`
export const ExpeditieButtonWrap = styled(StyledButtonWrap)`
  justify-content: space-between;
`;

export const MobileButtonWrap = styled.div`
    @media(max-width: 767px) {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        padding: 1.5rem;
        display: flex;
        justify-content: space-between;
        z-index: 2;
        button {
            width: 45%;
            padding: .7rem;
            border-radius: 8px;
            margin-top: 1rem;
        }
        box-shadow: 0px 5px 9.5px 0.5px rgba(0, 0, 0, 0.3);
        flex-wrap: wrap;
    }
`

export const ExpeditieMobileButtonWrap = styled(MobileButtonWrap)`
  @media(min-width: 767px) {
    justify-content: end;
    width: 80%;
    align-items: end;
    input {
        width: 100%;
        max-width: 300px;
        position: static;
        padding: 0.45rem 0.8rem;
        border-radius: .45rem;
    }
  }  
  display: flex;  
  @media(max-width: 767px) {
    flex-direction: column;
    input {
        margin-top: 1rem;
    }
  }
  > div {
    margin: 0 .4rem;
    &:last-child {
        margin-right: 0;
    }
  }
`;

interface Props {
    children: ReactNode
}

const ButtonWrap = ({children}: Props) => (

    <StyledButtonWrap>
        {children}
    </StyledButtonWrap>
);

export default ButtonWrap;